import { IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React, { useEffect, useState } from 'react';

const useMaintenanceNoticeState = (): [boolean, (v: boolean) => void] => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (
      process.env.GATSBY_MAINTENANCE_NOTICE_ENABLED === 'true' &&
      (!sessionStorage ||
        sessionStorage.getItem('meetrix-maintenance-notice') !== 'false')
    ) {
      setShow(true);
      sessionStorage?.setItem('meetrix-maintenance-notice', 'true');
    }
  }, []);

  return [
    show,
    (v: boolean) => {
      setShow(v);
      sessionStorage?.setItem('meetrix-maintenance-notice', 'false');
    },
  ];
};

const NoticeBanner = () => {
  const [show, setShow] = useMaintenanceNoticeState();

  if (show && process.env.GATSBY_MAINTENANCE_NOTICE_ENABLED === 'true')
    return (
      <div className="notice-banner">
        <IconButton
          aria-label="delete"
          className="close-button"
          onClick={() => setShow(false)}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="body1" component="pre">
          {process.env.GATSBY_MAINTENANCE_NOTICE}
        </Typography>
      </div>
    );

  return null;
};

export default NoticeBanner;
